module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('b-switch', {
    model: {
      value: (_vm.openOnFocus),
      callback: function($$v) {
        _vm.openOnFocus = $$v
      },
      expression: "openOnFocus"
    }
  }, [_vm._v("\n                Open dropdown on focus\n            ")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.keepFirst),
      callback: function($$v) {
        _vm.keepFirst = $$v
      },
      expression: "keepFirst"
    }
  }, [_vm._v("\n                Keep-first "), _c('small', [_vm._v("(will always have first option pre-selected)")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selected))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Find a name"
    }
  }, [_c('b-autocomplete', {
    attrs: {
      "placeholder": "e.g. Anne",
      "keep-first": _vm.keepFirst,
      "open-on-focus": _vm.openOnFocus,
      "data": _vm.filteredDataObj,
      "field": "user.first_name"
    },
    on: {
      "select": function (option) { return _vm.selected = option; }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-374a7ac6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/autocomplete/examples/ExObjArray.vue
// module id = 962
// module chunks = 6 60